<template>
    <BorrarModalComponent
        :name="'borrar-' + abonado.id"
        :title="'Borrar abono de ' + abonado.name + ' ' + abonado.surnames"
        borrarTitle="Datos del abonado"
        confirmButton="¿BORRAR ABONO?"
        v-on:close="() => close(false)"
        v-on:confirm="() => borrarAbonado()"
    >
        <ul class="list-group list-group-unbordered mb-3">
            <li class="list-group-item">
                <b>Nª de abonado:</b> <a>{{ abonado.n_abonado }}</a>
            </li>
            <li class="list-group-item">
                <b>Nombre:</b> <a>{{ abonado.name }}</a>
            </li>
            <li class="list-group-item">
                <b>Apellidos:</b> <a>{{ abonado.surnames }}</a>
            </li>
            <li class="list-group-item">
                <b>DNI:</b> <a>{{ abonado.dni }}</a>
            </li>
            <li class="list-group-item">
                <b>Email:</b> <a>{{ abonado.email }}</a>
            </li>
            <li class="list-group-item">
                <b>Asiento Zona:</b>
                <a>
                    <template v-if="abonado.tiene_asiento">
                        <strong>Zona:</strong> {{ abonado.asiento.region }}, Fila: {{ abonado.asiento.row }}, Butaca: {{ abonado.asiento.seat }}
                    </template>
                    <template v-else>
                        Sin asiento
                    </template>
                </a>
            </li>
        </ul>
    </BorrarModalComponent>
</template>

<script>
    import BorrarModalComponent from "../../../../components/backend/components/BorrarModalComponent";

    export default {
        props: ['abonado'],
        data() {
            return {
                borrado: false
            }
        },
        methods: {
            close() {
                this.$emit('close', 'borrar-' + this.abonado.id, this.borrado);
            },
            borrarAbonado() {
                const params = {
                    filters : {},
                    abonado_id: this.abonado.id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.abonados.borrar'), params).then(res => {
                    this.borrado = true;
                    this.$toast.success("Abonado borrado");
                    this.close();
                });
            }
        },
        components: {
            BorrarModalComponent
        }
    }
</script>
